export const content = {
  ui: {
    buildingType: 'Gebäudetyp',
    buildingProject: 'Bauvorhaben',
  },
  headline: 'Art des Gebäudes',
}
